var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoneAllRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.7 17.6q-.2 0-.375-.075T6 17.3l-4.225-4.225Q1.5 12.8 1.5 12.363t.275-.713q.275-.275.7-.275t.7.275l3.55 3.55l1.4 1.4l-.725.7q-.15.15-.325.225T6.7 17.6Zm5.65-.025q-.2 0-.375-.062t-.325-.213L7.4 13.05q-.275-.275-.275-.713t.275-.712q.275-.275.7-.275t.7.275l3.55 3.55l8.5-8.5q.275-.275.7-.275t.7.275q.275.275.275.713t-.275.712l-9.2 9.2q-.15.15-.325.213t-.375.062Zm0-5.225l-1.425-1.4l4.25-4.25q.275-.275.713-.275t.712.275q.275.275.275.7t-.275.7l-4.25 4.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneAllRounded);
export default __webpack_public_path__ + "static/media/done-all-rounded.4a209be6c9a0464ce7662f511411f95c.svg";
export { ForwardRef as ReactComponent };